module.exports = __webpack_public_path__ + "img/index08.1ad0614f.jpg";